<template>
	<b-container>
		<b-row class="mb-5" align-h="start">
			<b-col cols="3">
				<b-button variant="info" size="sm" @click="$router.go(-1)">Vissza</b-button>
			</b-col>
			<b-col cols="6">
				<b-row cols="1">
					<b-col class="text-center"><h1>{{ formType }} hívás</h1></b-col>
					<b-col class="text-center">{{showCrisisSuicideCovid(form.crisis, form.suicide, form.covid)}}</b-col>
				</b-row>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<h5>{{form.id.year}}-{{form.id.officeId}}-{{form.id.id}}</h5>
			</b-col>
		</b-row>
		<b-row class="mb-3" align-h="between">
			<b-col cols="6" class="border p-4">
				<span class="font-weight-bold">Hívás kezdete:</span> {{ form.reportTime }}
			</b-col>
			<b-col cols="6" class="border p-4">
				<span class="font-weight-bold">Hívás vége:</span> {{ form.endReportTime}}
			</b-col>
		</b-row>
		<b-row class="mb-3">
			<b-col cols="4" class="text-center">
				<span class="font-weight-bold">Hívó kora:</span> {{ form.age }}
			</b-col>
			<b-col cols="4" class="text-center">
				<span class="font-weight-bold">Hívó neme:</span> {{ form.sex }}
			</b-col>
			<b-col cols="4" class="text-center">
				<span class="font-weight-bold">Hívás gyakorisága:</span> {{ form.callFrequency }}
			</b-col>
		</b-row>
		<textbox label="Első fontos mondatok" :text="form.firstSentences" />
		<textbox label="Hívó elnevezése, jellemző leírása" :text="form.callerDescription" />
		<textbox label="Beszélgetés rövid tartalma (a hívó kulcsmondataival)" :text="form.shortContent" />
		<textbox label="Ügyelő megjegyzései, rövid válaszai" :text="form.helperDescriptions" />

		<problem-view :problems="form.problems" />
		<b-row>
			<b-col>
				<unordered-list label="Hívó elvárásai" :items="form.expectations" />
			</b-col>
			<b-col>
				<unordered-list label="Irányitás, intézkedés" :items="form.actions" />
			</b-col>
			<b-col>
				<unordered-list label="Terápiás alapelemek" :items="form.therapies" />
			</b-col>
			<b-col>
				<unordered-list label="Segítő kapcsolat szintjei" :items="form.relationLevel" />
			</b-col>
		</b-row>
		<b-row cols="1" cols-md="3" cols-lg="5" class="additional-info justify-content-center">
			<b-col v-if="form.collaboration" class="text-center">
				<div class="additional-info-box">
				<label>Hívóval való összhang</label>
				<p>{{ form.collaboration }}</p>
				</div>
			</b-col>
			<b-col v-if="form.efficiency" class="text-center">
				<div class="additional-info-box">
					<label>Beszélgetés hatékonysága</label>
					<p>{{ form.efficiency }}</p>
				</div>
			</b-col>
			<b-col v-if="form.callerSatisfied" class="text-center">
				<div class="additional-info-box">
					<label>Hívó elégedett</label>
					<p>{{ form.callerSatisfied }}</p>
				</div>
			</b-col>
			<b-col v-if="form.helperSatisfied" class="text-center">
				<div class="additional-info-box">
					<label>Segítő elégedett</label>
					<p>{{ form.helperSatisfied }}</p>
				</div>
			</b-col>
			<b-col v-if="form.maritalState" class="text-center">
				<div class="additional-info-box">
					<label>Családi állapot</label>
					<p>{{ form.maritalState }}</p>
				</div>
			</b-col>
			<b-col v-if="form.profession" class="text-center">
				<div class="additional-info-box">
					<label>Foglalkozás</label>
					<p>{{ form.profession }}</p>
				</div>
			</b-col>
			<b-col v-if="form.publicCared" class="text-center">
				<div class="additional-info-box">
					<label>Volt-e állami gondozott?</label>
					<p>{{ form.publicCared }}</p>
				</div>
			</b-col>
			<b-col v-if="form.childrenNumber" class="text-center">
				<div class="additional-info-box">
					<label>Gyerekeinek száma</label>
					<p>{{ form.childrenNumber }}</p>
				</div>
			</b-col>
			<b-col v-if="form.orderInSiblings" class="text-center">
				<div class="additional-info-box">
					<label>Hányadik gyerek?</label>
					<p>{{ form.orderInSiblings }}</p>
				</div>
			</b-col>
			<b-col v-if="form.divorceCount" class="text-center">
				<div class="additional-info-box">
					<label>Válásainak száma</label>
					<p>{{ form.divorceCount }}</p>
				</div>
			</b-col>
		</b-row>
		<b-row align-h="center" class="final">
			<b-col cols="1">
				<b-button variant="info" @click="$router.go(-1)">Vissza</b-button>
			</b-col>
		</b-row>
	</b-container>
</template>
<script>
import FormService from '@/services/FormService'
import ProblemView from '@/components/ProblemView'
import UnorderedList from '@/components/UnorderedList'
import Textbox from '@/components/Textbox'

export default {
	name: 'form-view',
	components: { ProblemView, UnorderedList, Textbox },
	data() {
		return {
			form: {
				id: {},
		        user: '',
		        reportTime: '',
		        endReportTime: '',
		        type: 'adequate',
		        age: 0,
		        sex: '',
		        callFrequency: '',
		        callerDescription: '',
		        firstSentences: '',
		        shortContent: '',
		        helperDescriptions: '',
		        problems: [],
		        expectations: [],
		        relationLevel: [],
		        actions: [],
		        therapies: [],
		        collaboration: '',
		        efficiency: '',
		        callerSatisfied: '',
		        helperSatisfied: '',
		        maritalState: '',
		        profession: '',
		        publicCared: '',
		        childrenNumber: null,
		        orderInSiblings: null,
		        siblingsNumber: null,
		        divorceCount: null,
		        crisis: false,
		        suicide: false,
		        covid: false,
		        inadequateCallType: ''
		    },
			formType: 'Adekvát'
		}
	},
	async mounted() {
		const service = new FormService()
		this.form = await service.getForm(this.$route.params.id, this.$session.get('token'))
		this.setFormType()
	},
	methods: {
		setFormType() {
			this.formType = this.form.type == 'adequate' ? 'Adekvát' : 'Inadekvát'
		},
		showCrisisSuicideCovid(crisis, suicide, covid) {
			let texts = []
			if (crisis) texts.push('krízis')
			if (suicide) texts.push('szuicid')
			if (covid) texts.push('covid')

			return texts.join(' - ')
		}
	}
}
</script>
<style scoped>

	.final {
		margin: 4rem 0 2rem;
	}

	.additional-info-box label {
		font-weight: bold;
	}

	.additional-info-box {
		background: rgb(241, 241, 241);
		padding: 0.5rem 1rem;
	}
</style>
